import { createContext } from 'react';

// This file is kept separate to avoid HMR issues.
// The context is created and provided by the Auth component.
export const AuthContext = createContext(null);
